import { QuestionsStatisticsPage } from "./QuestionsStatisticsPage";
export default QuestionsStatisticsPage;
